// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"ffb49725","61":"fe2e93ce","87":"169173b7","350":"d9564ded","376":"b06aedf3","379":"65f9653e","393":"463fb97d","660":"6c70cc79","766":"d9cd850d","768":"8a6f3f3e"}[chunkId] + ".chunk.css";
};